// Components==============
import { faAngleUp, faTimes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RichText from 'components/UI/RichText/RichText';
import Video from 'components/UI/TrainingContent/Video/Video';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import PreviewToken from '../PreviewToken/PreviewToken';
import './TokenModal.module.scss';
// =========================

export default function TokenModal({
  open,
  hidden,
  toggle,
  token,
  tokens,
  top,
}: {
  open: boolean;
  hidden: boolean;
  toggle: () => void;
  top: number;
  tokens: { activities: any; phases: any };
  token: {
    id: number;
    name: string;
    thumbnail?: string;
    image?: string;
    phases: any;
    summary: any;
    description: any;
    video: string;
  };
}) {
  function getSuggestions() {
    const activities = Object.values(tokens.activities);
    const suggestion_arr: any = [];

    if (token.phases) {
      const phasesToMatch = token.phases;

      phasesToMatch.forEach((phase: any) => {
        activities.forEach((activity: any) => {
          if (activity.phases.indexOf(phase) !== -1) {
            if (
              !suggestion_arr.find((act: any) => act === activity) &&
              activity !== token
            ) {
              suggestion_arr.push(activity);
            }
          }
        });
      });
    } else if (token.id) {
      const phase = token.id;
      activities.forEach((activity: any) => {
        if (activity.phases.indexOf(phase) !== -1) {
          if (!suggestion_arr.find((act: any) => act === activity)) {
            suggestion_arr.push(activity);
          }
        }
      });
    }
    return suggestion_arr;
  }

  const suggestions = getSuggestions();

  const translate = useTranslate();

  return (
    <div
      styleName={`popup-background ${open ? 'expanded' : ''} ${
        hidden ? 'hidden' : ''
      }`}
      style={{ top }}
    >
      <div styleName="popup">
        <>
          <div styleName="container">
            <div styleName="top" onClick={toggle}>
              <h1>{token.name}</h1>
              {open ? (
                <FontAwesomeIcon styleName="icon" icon={faTimes} />
              ) : (
                <FontAwesomeIcon styleName="icon" icon={faAngleUp} />
              )}
            </div>
            {!!token.video && <Video link={token.video} />}
            <p>{token.summary}</p>
            <RichText content={token.description} />
          </div>
          {!!suggestions.length && (
            <div styleName="suggestion">
              <h3>{translate('scan.block-suggestion.label')}</h3>
              <p>
                {translate('scan.block-suggestion.description')}{' '}
                <b>{token.name}</b>
              </p>
              <div styleName="suggestionContainer">
                {suggestions?.map((suggestion: any, index: number) => (
                  <PreviewToken key={index} token={suggestion} />
                ))}
              </div>
            </div>
          )}
        </>
      </div>
    </div>
  );
}
